export default {
    SPARE: 'rgb(255, 242, 146)',
    OFF: 'rgb(251, 192, 187)',
    DEFAULT: 'rgb(255, 255, 255)'
}
